import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = [
  ...restApiStates(['store-items'], 'storeItem', true, true, true),
  ...restApiStates(['store-items', 'image'], 'storeItemsImage', false, false),
  ...restApiStates(['market-place-products'], 'storeItem', true, true, true),
];

const instantStates = [];
const storage = {};
const listValues = ['storeItems', 'storeItemsImages'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
